import req from './request'

const DEFAULT_ENDPOINTS = {
    aiStatisticWork: '/reports/ai-statistic/work',
    aiCandidatesRegistrations: '/reports/ai-statistic/registration',
    reportsDriversAi:'/reports/drivers-ai',
    reportsCandidatesAi:'/reports/candidates-ai/candidates',
    reportsCandidatesAiFin: '/reports/candidates-ai/registrations',
    reportsChatsAi:'/reports/chats-ai'
}

export default {
    aiStatisticWork(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.aiStatisticWork, param)
    },
    aiCandidatesRegistrations(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.aiCandidatesRegistrations, param)
    },
    reportsDriversAi(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.reportsDriversAi, param)
    },
    reportsCandidatesAi(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.reportsCandidatesAi, param)
    },
    reportsChatsAi(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.reportsChatsAi, param)
    },
    reportsCandidatesAiFin(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.reportsCandidatesAiFin, param)
    },
}